import { Booking } from "@ciptex/notified";
import { Badge } from "@twilio-paste/core/badge";
import { Box } from "@twilio-paste/core/box";
import { FC } from "react";

interface OptionsType {
    booking: Booking | undefined;
  }

export const OptionsInfo: FC<OptionsType> = ({ booking  }) => {
	return (<Box display="flex" flexDirection="row" flexWrap="wrap" flex="9" columnGap="space30" rowGap="space30">
		{booking?.event.isHighAlert && <Badge as="span" variant="info">High Alert</Badge>}
		{booking?.options?.hasQaSession && <Badge as="span" variant="info">Q&amp;A Session</Badge>}
		{booking?.options?.hasVideo && <Badge as="span" variant="info">Video</Badge>}
		{booking?.options?.language && <Badge as="span" variant="info">{booking.options.language}</Badge>}
	</Box>);
}